<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v">
<h1 class="tochead">Contents</h1>
</a><h2 class="toc1"><a id="page_v"></a><a href="#/xhtml/05_Foreword"><em class="italic">Foreword</em></a></h2>
<h2 class="toc2"><a href="#/xhtml/05_Foreword#sec1">Matthias Strohn</a></h2>
<h2 class="toc3"><a href="#/xhtml/06_Introduction"><em class="italic">Introduction</em></a></h2>
<h2 class="toc3"><a href="#/xhtml/07_Maps"><em class="italic">Maps</em></a></h2>
<h2 class="tocb"><span href="#/xhtml/08_Ranks" title="Link target outside of Sample"><em class="italic">German and British Ranks</em></span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter01" title="Link target outside of Sample"><span class="toc_hang">1</span> The East Wall at the Dnieper</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter02" title="Link target outside of Sample"><span class="toc_hang">2</span> The battle of Kirovograd</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter03" title="Link target outside of Sample"><span class="toc_hang">3</span> Psychological Stresses</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter04" title="Link target outside of Sample"><span class="toc_hang">4</span> In expectation of the new attack 17–25 January 1944</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter05" title="Link target outside of Sample"><span class="toc_hang">5</span> The encirclement of XI Army Corps (Stemmermann) and XXXXII Army Corps (Lieb)</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter06" title="Link target outside of Sample"><span class="toc_hang">6</span> The relief attacks</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter07" title="Link target outside of Sample"><span class="toc_hang">7</span> In the Korsun pocket</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter08" title="Link target outside of Sample"><span class="toc_hang">8</span> The breakout from the pocket</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter09" title="Link target outside of Sample"><span class="toc_hang">9</span> Victory celebrations on both sides</span></h2>
<h2 class="toc1"><span href="#/xhtml/18_Appendix" title="Link target outside of Sample"><em class="italic">Appendix: German troop formations involved in the fighting, 5 January–17 February 1944</em></span></h2>
<a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?34d7ab41